"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var es6_object_assign_1 = __importDefault(require("es6-object-assign"));
es6_object_assign_1.default.polyfill();
var vue3_logger_1 = __importDefault(require("./vue3-logger"));
exports.default = vue3_logger_1.default;
//# sourceMappingURL=index.js.map